import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

const trackShare = (type, value, label) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'collateral', type, value, label).then(() => {});
    });
  });
};

// And all buttons should have a trackShare on click listener
// onClick={() => trackShare('carousel', parsedTitle)}

const parseTrackingType = (type) => {
  switch (type) {
    case 'web':
    case 'iframe':
      return 'web';
    default:
      return type;
  }
};

export default class LinkHandler extends Component {
  constructor(props) {
    super(props);

    this.getFavoriteElement = this.getFavoriteElement.bind(this);
    this.getLinkElement = this.getLinkElement.bind(this);
  }

  getLinkElement(typeOverride = null) {
    const {
      UniqueID,
      children,
      className,
      dataFancybox,
      dataOptions,
      dataTrigger,
      page,
      type: typeProp,
      subType,
      title,
      url,
    } = this.props;

    const type = typeOverride || typeProp;
    const pageNames = { f: 'promote', t: 'sell' };

    const fancyBoxProps = {
      'data-fancybox': dataFancybox,
      'data-options': dataOptions,
      'data-fancybox-trigger': dataTrigger,
    };
    const parsedTitle = title.toLowerCase().replace(/-/g, '---').replace(/ /g, '-');

    let shareValue = type;
    if (type === 'collection') {
      shareValue = `${window.location.host}/main/${pageNames[page]}/${parsedTitle}`;
    } else if (type === 'weblink') {
      shareValue = url;
    }

    const commonProps = {
      className,
      key: UniqueID,
      onClick: () => trackShare(parseTrackingType(type), shareValue, title),
    };

    const { info } = this.props;
    let chapterData = {};
    let pageRetain = 0;
    let prevPage = 0;

    if (info) {
      chapterData = info.chapter; // Use 'chapterData' to refer to the chapter information

      pageRetain = info.page;
      prevPage = Math.max(pageRetain - 1, 0); // Ensure the page number doesn't go below 0
    }

    if (url.includes('https://stack.travpromobile.com/instagram.php?embed_id=')) {
      const fancyOptions = {
        infobar: true,
        thumbs: {
          autoStart: true,
          axis: 'x',
        },
        baseClass: 'customBox',
        buttons: ['thumbs', 'close'],
      };
      return (
        <a
          onClick={() => trackShare('web', url, title)}
          data-type="iframe"
          data-src={url}
          href={url}
          {...fancyBoxProps}
          {...commonProps}
          data-options={JSON.stringify(fancyOptions)}
        >
          {children}
        </a>
      );
    }

    const itemType = type === 't' ? subType : type;
    switch (itemType) {
      case 'carousel':
      case 'collection':
        return (
          <Link
            onClick={() =>
              trackShare(
                'carousel',
                `${window.location.href}/main/${pageNames[page]}/${parsedTitle.replace('&', '%26')}`,
                title,
              )
            }
            to={`/main/${pageNames[page]}/${parsedTitle.replace('&', '%26')}`}
            {...commonProps}
          >
            {children}
          </Link>
        );

      case 'image_library':
        return (
          <Link
            onClick={() => trackShare('carousel', title, title)}
            to={`promote/${url}`}
            key={UniqueID}
            className={className}
          >
            {children}
          </Link>
        );

      case 'video_library':
        return (
          <Link
            onClick={() => trackShare('carousel', title, title)}
            to={`promote/${url}`}
            key={UniqueID}
            className={className}
          >
            {children}
          </Link>
        );

      case 'internal-link':
        return (
          <Link onClick={() => trackShare('carousel', title, title)} to={`${url}`} key={UniqueID} className={className}>
            {children}
          </Link>
        );

      case 'weblink':
      case 'web':
        return (
          <a
            onClick={() => trackShare('web', url, title)}
            href={url}
            target="_blank"
            rel="noreferrer noopener"
            {...commonProps}
          >
            {children}
          </a>
        );

      case 'iframe':
      case 'iframe-link':
        return (
          <a
            onClick={() => trackShare('web', url, title)}
            data-type="iframe"
            data-src={url}
            href={url}
            {...fancyBoxProps}
            {...commonProps}
          >
            {children}
          </a>
        );

      case 'contact_us':
      case 'contact':
        return (
          <Link onClick={() => trackShare('contact-us', url, title)} to="/main/sell/contact" {...commonProps}>
            {children}
          </Link>
        );

      case 'directory':
        return (
          <Link onClick={() => trackShare('directory', url, title)} to="/main/directory" {...commonProps}>
            {children}
          </Link>
        );

      case 'infographic':
      case 'image':
        return (
          <a
            onClick={() => trackShare('infographic', url, title)}
            data-src={url}
            {...fancyBoxProps}
            {...commonProps}
            onKeyDown={() => trackShare('infographic', url, title)}
            role="button"
            tabIndex="0"
          >
            {children}
          </a>
        );

      case 'pdf':
        return (
          <div
            onClick={() => trackShare('pdf', url, title)}
            data-src={`https://stack.travpromobile.com/viewer.php?file=${url}`}
            data-fancybox={dataFancybox}
            data-options={dataOptions}
            data-fancybox-trigger={dataTrigger}
            className={className}
            key={UniqueID}
            onKeyDown={() => trackShare('pdf', url, title)}
            role="button"
            tabIndex="0"
          >
            {children}
          </div>
        );
      case 'p':
        return (
          <Link to={`ret/chapter/${chapterData}/${prevPage}`} className="favorite__button" key={UniqueID}>
            {children}
          </Link>
        );

      case 'brochure':
        return (
          <div
            onClick={() => trackShare('pdf', url, title)}
            data-src={url}
            data-fancybox={dataFancybox}
            data-options={dataOptions}
            data-fancybox-trigger={dataTrigger}
            className={className}
            key={UniqueID}
            onKeyDown={() => trackShare('pdf', url, title)}
            role="button"
            tabIndex="0"
          >
            {children}
          </div>
        );

      case 'multi':
        return (
          <a data-src={`#${UniqueID}`} {...fancyBoxProps} {...commonProps}>
            {children}
          </a>
        );

      default:
        return (
          <a href={url} target="" {...fancyBoxProps} {...commonProps}>
            {children}
          </a>
        );
    }
  }

  getFavoriteElement() {
    const { UniqueID, children, info, type } = this.props;

    const { chapter, page } = info;

    // t = Promote or Sell item
    if (type === 't') return this.getLinkElement(type);
    // p = Training Content Page
    if (type === 'p')
      return (
        <Link to={`ret/chapter/${chapter}/${page - 1}`} className="favorite__button" key={UniqueID}>
          {children}
        </Link>
      );
    return null;
  }

  render() {
    const { favorites } = this.props;

    return <div>{favorites ? this.getFavoriteElement() : this.getLinkElement()}</div>;
  }
}

LinkHandler.propTypes = {
  UniqueID: PropTypes.string.isRequired,
  appId: PropTypes.number,
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  dataFancybox: PropTypes.string.isRequired,
  dataOptions: PropTypes.string.isRequired,
  dataTrigger: PropTypes.string.isRequired,
  favorites: PropTypes.bool,
  info: PropTypes.shape({
    chapter: PropTypes.string,
    page: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  page: PropTypes.string,
  subType: PropTypes.string,
  type: PropTypes.string.isRequired,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

LinkHandler.defaultProps = {
  appId: -1,
  favorites: false,
  info: {},
  page: 'f',
  subType: 't',
  url: '#',
};
